// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".custom-html[data-v-1e45f9f4] th{font-weight:bold}.custom-html[data-v-1e45f9f4] td,.custom-html[data-v-1e45f9f4] th{min-width:110px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
